<template>
    <div>
        <div style="margin-bottom: 10px;display:flex;">
            <span style="margin-right: 10px">授权应用</span>
           <el-checkbox-group v-model="appList" @change="checkchange">
                <el-checkbox  v-for="(item,index) in sqtypedata" :key="index" :label="item.appId" :indeterminate="item.checked">
                    {{item.name}}
                </el-checkbox>
           </el-checkbox-group>
        </div>
        <el-table
                class="mrt10"
                ref="innertable"
                size="mini"
                border
                @selection-change="selectchange"
                :data="tableData"
                max-height="400"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="true"
                style="width: 100%">
            <el-table-column
                    align="center"
                    label="姓名"
                    prop="name" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="部门"
                    prop="dept" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="手机号"
                    show-overflow-tooltip>
                <template slot-scope="scope" >
                    <span>{{scope.row.phone==''?'无':scope.row.phone}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="授权应用"
                    show-overflow-tooltip
            >
                <template slot-scope="scope" >
                    <span>{{scope.row.app==''?'无':scope.row.app.substring(0,scope.row.app.length-1)}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    align="center"
                    width="70"
                    label="是否同步"
                    prop="isSync">
                <template slot-scope="scope" >
                    <span v-if="scope.row.isSync==0" style="font-weight: 700">未同步</span>
                    <span v-if="scope.row.isSync==-1" style="font-weight: 700;color: red">同步失败</span>
                    <span v-if="scope.row.isSync==1" style="color: #2b89fd;font-weight: 700">已同步</span>
                    <span v-if="scope.row.isSync==2" style="color: #E89112;font-weight: 700">同步中</span>
                </template>
            </el-table-column>

        </el-table>

        <div style="display:flex;justify-content: center;margin-top: 20px">
            <el-button type="primary" @click="onSubmit" size="mini" :disabled="savebtn">{{$t('button_save')}}</el-button>
            <el-button @click="close" size="mini">取消</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from ".././api.js"
    import {mapActions} from "vuex";

    export default {
        name: "shouquan",
        props:{
            selectalldata:{
              type:Array,
              required:true
            },
            deptid:{
                type:Number,
                required:true
            }
        },
        data() {
            return {
                appList:[],
                pageSize:10,
                currentPage:1,
                tableData:[],
                savejudge:1,
                sqtypedata:[],
                total:0,
                savebtn:false,
                savedata:[],
                oldList:[],
                banxuanList:[]
            }
        },
        mounted() {
            this.savejudge=1
            this.tableData=JSON.parse(JSON.stringify(this.selectalldata))
            this.tableData.forEach(item=>{
                this.$set(item,'allid',[])
                if(item.appId!=''){
                    item.allid=item.appId.substring(0,item.appId.length-1).split(',')
                }
            })
            this.getAppList()
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            checkchange(e){
                this.appList=e
                this.sqtypedata.forEach(item=>{
                    e.map(oitem=>{
                        if(item.appId==oitem){
                            this.$set(item,'checked',false)
                        }
                    })
                })
            },

            close(){
                this.$emit('closedialog')
            },
            onSubmit(){
                // if(this.appList.length==0){
                //     this.$message.error('请选择应用授权后保存')
                // }else{
                    if(!this.savebtn){
                        this.authWxApp()
                    }
                // }
            },
            selectchange(e){
                // this.savedata=e
                if(this.savejudge>=3){
                    this.savedata=e
                }else{
                    this.savejudge++
                }
                // console.log(e)

            },
            //分页

            async getAppList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    type:this.deptid==0?1:(this.deptid==-1?2:1)
            }
                let res = await API.getAppList(params);
                if (res.code == 1) {
                    this.sqtypedata=res.data
                    this.sqtypedata.forEach(oitem=>{
                        this.$set(oitem,'num',0)
                        this.tableData.forEach(item=>{
                            item.allid.forEach(iitem=>{
                                if(parseFloat(iitem)==parseFloat(oitem.appId)){
                                    oitem.num++
                                }
                            })
                    })
                    })

                    this.sqtypedata.forEach(item=>{
                        if(item.num==this.tableData.length){
                            this.appList.push(item.appId)
                        }
                    })
                    this.sqtypedata.map(item=>{
                        this.$set(item,'checked',false)

                        if(item.num > 0&&item.num!=this.tableData.length){
                            this.$set(item,'checked',true)
                            this.banxuanList.push(item.appId)
                        }
                    })
                    this.oldList=JSON.parse(JSON.stringify(this.appList))
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async authWxApp(){
                this.savebtn=true
                let a=[]
                    this.tableData.forEach(item=>{
                        a.push({
                            id:item.id,
                            platUid:item.platUid
                        })
                    })
                let b=[]
                let c=[]
                let d=[]
                let e=[]
                if(this.banxuanList.length!==0&&this.oldList.length==0){
                    this.sqtypedata.forEach(item=>{
                        this.appList.map(oitem=>{
                            if(item.appId==oitem&&item.checked==false){
                                b.push({
                                    id:item.id,
                                    appId:item.appId,
                                    name:item.name,
                                    isInner:item.isInner
                                })
                                // this.$set(item,'checked',false)
                            }
                        })
                    })
                    d=this.banxuanList.filter(item=>{
                        return this.appList.indexOf(item)==-1
                    })
                    this.sqtypedata.forEach(item=>{
                        if(d.indexOf(item.appId)>-1&&item.checked!==true){
                            c.push({
                                id:item.id,
                                appId:item.appId,
                                name:item.name,
                                isInner:item.isInner
                            })
                        }
                    })
                }else if(this.banxuanList.length==0&&this.oldList.length>0){

                    e=this.appList.filter(item=>!this.oldList.some(item1=>item==item1))
                    d=this.oldList.filter(item=>!this.appList.some(item1=>item1==item))
                    this.sqtypedata.forEach(item=>{

                        if(d.indexOf(item.appId)>-1){
                            c.push({
                                id:item.id,
                                appId:item.appId,
                                name:item.name,
                                isInner:item.isInner
                            })
                        }
                        if(e.indexOf(item.appId)>-1){
                            b.push({
                                id:item.id,
                                appId:item.appId,
                                name:item.name,
                                isInner:item.isInner
                            })
                        }
                    })
                }else{
                    e=this.appList.filter(item=>!this.oldList.some(item1=>item==item1))
                    d=this.oldList.filter(item=>!this.appList.some(item1=>item1==item))
                    this.sqtypedata.forEach(item=>{

                        if(d.indexOf(item.appId)>-1){
                            c.push({
                                id:item.id,
                                appId:item.appId,
                                name:item.name,
                                isInner:item.isInner
                            })
                        }
                        this.banxuanList.forEach(oitem=>{
                            if(oitem==item.appId&&item.checked==false&&this.appList.indexOf(oitem)==-1)
                                c.push({
                                    id:item.id,
                                    appId:item.appId,
                                    name:item.name
                                })
                                })
                        if(e.indexOf(item.appId)>-1){
                            b.push({
                                id:item.id,
                                appId:item.appId,
                                name:item.name,
                                isInner:item.isInner
                            })
                        }
                    })
                }
                if(b.length==0&&c.length==0){
                    this.$message.warning('未进行数据修改')
                    this.savebtn=false
                    return
                }
                let param = {
                    addAppList:b,
                    delAppList:c,
                    // appList:this.appList,
                    userList:a
                };
                let res = await API.authWxApp(param);
                if (res.code == 1) {
                    this.$emit('savesuccess')

                    this.savebtn=false

                    this.$message.success(res.message)
                } else if (res.code == -2) {
                    this.savebtn=false

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.savebtn=false

                    this.$message.error(res.message);
                }
            },


        }
    }
</script>

<style lang="scss" scoped>
    .flexother {
        display: flex;
        flex-flow: wrap;
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }
    /deep/.has-gutter .el-checkbox__input{
        display: none;
    }
    .choosepage{
        /*min-width: 41.571rem;*/
        width:90%
    }
</style>